import { useAppContext } from 'contexts/AppContext';
import { isUserRole } from 'globals/utils';
import { UserRole } from 'globals/types';

export const useRole = (roles: UserRole | UserRole[]): boolean => {
  const { userRole } = useAppContext();

  return isUserRole(userRole, roles);
};
